import { render, staticRenderFns } from "./spreadBase.vue?vue&type=template&id=7008182b&"
import script from "./spreadBase.vue?vue&type=script&lang=js&"
export * from "./spreadBase.vue?vue&type=script&lang=js&"
import style0 from "./spreadBase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports